import { render, staticRenderFns } from "./EditManagerToOrder.vue?vue&type=template&id=978f66b2"
import script from "./EditManagerToOrder.vue?vue&type=script&lang=js"
export * from "./EditManagerToOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports